import { createTheme } from '@mui/material/styles';

// Define the palette
const palette = {
	primary: {
		main: '#FFA939',
		light: '#FFA939',
		dark: '#B27627',
		darkest: '#331D00',
		contrastText: '#331D00',
	},
	secondary: {
		main: '#47A8BE',
		contrastText: 'rgba(255, 255, 255, 0.96)',
	},
	text: {
		main: '#242834',
		light: '#525866',
	},
	neutral: {
		main: '#717A8E',
		light: '#E4E7EC',
		lighter: '#F6F8FA',
	},
	danger: {
		main: '#FE1B1B',
		contrastText: '#FFFFFF',
	},
	custom: {
		linkBlue: '#009CC6',
	},
};

// Define the typography
const typography = {
	fontFamily: 'Inter, sans-serif',
	h2: { fontSize: '1.5rem', fontWeight: 700, color: palette.text.main },
	h3: { fontSize: '1.25rem', fontWeight: 500, color: palette.text.main, lineHeight: '1.75rem' },
	subtitle1: {
		fontSize: '1rem',
		fontWeight: 500,
		textAlign: 'center',
		lineHeight: '1.5rem',
		color: palette.text.light,
	},
	body1: { fontSize: '0.875rem', fontWeight: 400, color: palette.text.light },
	footnote: { fontSize: '0.75rem', fontWeight: 300, color: palette.text.light },
};

// Define the components
const components = {
	MuiButton: {
		styleOverrides: {
			root: {
				textTransform: 'none',
				borderRadius: '0.625rem',
				boxShadow: 'none',
			},
		},
	},
	MuiDialog: {
		styleOverrides: {
			paper: {
				padding: '1.5rem',
				borderRadius: '1.5rem',
			},
		},
	},
	MuiLink: {
		styleOverrides: {
			root: {
				color: palette.custom.linkBlue,
				textDecoration: 'underline',
				'&:hover': {
					color: palette.custom.linkBlue,
					textDecoration: 'underline',
				},
			},
		},
	},
	MuiIconButton: {
		styleOverrides: {
			root: {
				'.MuiDialog-root &.close-button': {
					position: 'absolute',
					right: '1rem',
					top: '1rem',
					padding: '0',
					boxShadow: 'none',
				},
			},
		},
	},
};

// Create the theme instance
const theme = createTheme({
	palette,
	typography,
	components,
});

export default theme;
